import clsx from "clsx";
import React from "react";
import { PageContent } from "../Page";
import css from "./image-reference.module.scss";

export const enum ImageReferenceDirection
{
    Left,
    Right,
    Up,
    Down,
}

export enum LineColor
{
    White = '#FFFFFF',
    Orange = '#F26922',
}


interface ImageReferenceProps extends React.ComponentProps<"div">
{
    caption?: React.ComponentProps<typeof PageContent>;
    direction?: ImageReferenceDirection;
    mobileDirection?: ImageReferenceDirection;
    left?: number | string;
    lineWidth: number | string;
    lineHeight?: number | string;
    top?: number | string;
    mobileLeft?: number | string;
    mobileTop?: number | string;
    lineColor?: LineColor;
    mobileLineColor?: LineColor;
    onlyMobile?: boolean;
}

export const ImageReference = ({ caption, className, direction, left, lineWidth, style, top, mobileLeft, lineHeight, mobileTop, mobileDirection, lineColor, mobileLineColor = LineColor.Orange, onlyMobile = false  }: ImageReferenceProps): React.FunctionComponentElement<ImageReferenceProps> =>
{
    const lineColorClass = typeof lineColor === "string" && Object.values(LineColor).includes(lineColor) ?  lineColor : LineColor.Orange;
    const mobileLineColorClass = typeof mobileLineColor === "string" && Object.values(LineColor).includes(mobileLineColor) ?  mobileLineColor : lineColor;

    const styles: React.CSSProperties = {
        ["--left" as any]: typeof left === "number" ? `${left}px` : left,
        ["--top" as any]: typeof top === "number" ? `${top}px` : top,
        ["--line-width" as any]: typeof lineWidth === "number" ? `${lineWidth}px` : lineWidth,
        ["--line-height" as any]: typeof lineHeight === "number" ? `${lineHeight}px` : typeof lineWidth === "string" ? lineWidth : "0px",
        ["--mobile--left" as any]: typeof mobileLeft === "number" ? `${mobileLeft}px` : typeof mobileLeft === "string" ? mobileLeft : undefined,
        ["--mobile--top" as any]: typeof mobileTop === "number" ? `${mobileTop}px` : typeof mobileTop === "string" ? mobileTop : undefined,
        ["--line-color" as any]: lineColorClass,
        ["--mobile-line-color" as any]: mobileLineColorClass,
        ...style,
    };

    const classes = clsx(
        css["reference"],
        {
            [css["reference--left"]]: direction === ImageReferenceDirection.Left,
            [css["reference--right"]]: direction === ImageReferenceDirection.Right,
            [css["reference--up"]]: direction === ImageReferenceDirection.Up,
            [css["reference--down"]]: direction === ImageReferenceDirection.Down,
            [css["reference--mobile--left"]]: mobileDirection === ImageReferenceDirection.Left,
            [css["reference--mobile--right"]]: mobileDirection === ImageReferenceDirection.Right,
            [css["reference--mobile--up"]]: mobileDirection === ImageReferenceDirection.Up,
            [css["reference--mobile--down"]]: mobileDirection === ImageReferenceDirection.Down,
            [css["hidden-on-desktop"]]: onlyMobile,
        },
        className
    );

    return (
        <div className={classes} style={styles}>
            <div className={css["line"]} />
            {
                caption !== undefined && <PageContent {...caption} />
            }
        </div>
    );
}

// TODO: make line-width relative to image size